import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {useParams, useRouteMatch, Link, useHistory} from 'react-router-dom'

function ExhibitionDetail(){
    const [exhibition, setExhibition] = useState();
    let {id} = useParams();

    useEffect(()=>{
        getExhibition()
    }, [id])

    const history = useHistory();


    function getExhibition(){
        axios.get(`/api/get_exhibition/${id}`)
        .then(exhibitionDataFromMongo=>{
            setExhibition(exhibitionDataFromMongo.data)
        })
        .catch(error=>{
            console.log(error)
        })
    }

    const contemporary_art_tag = 
    <p>Contemporary Art</p>

    const modern_art_tag = 
    <p>Modern Art</p>

    const classic_art_tag = 
    <p>Classic Art</p>

    const ancient_art_tag = 
    <p>Ancient Art</p>

    const applied_fine_arts_tag = 
    <p>Applied Fine Arts</p>

    const photograph_tag = 
    <p>Photograph</p>

    const recommendation_tag = 
    <p>Recommendation</p>

    const free_admission_tag = 
    <p>Free Admission</p>

    return(
        <div className='detail'>
            {(exhibition)?<div>
            
            <div className='tag_in_exhibition_detail'>
             {(exhibition.genre =='Contemporary art')?contemporary_art_tag :''}
             {(exhibition.genre =='Modern art')?modern_art_tag :''}
             {(exhibition.genre =='Classic art')?classic_art_tag :''}
             {(exhibition.genre =='Ancient art')?ancient_art_tag :''}
             {(exhibition.genre =='Applied fine arts')?applied_fine_arts_tag :''}
             {(exhibition.genre =='Photograph')?photograph_tag :''}
             {(exhibition.isFreeAdmission =='Yes')?free_admission_tag :''}
             {(exhibition.isRecommendation =='Yes')?recommendation_tag :''}

            </div>

            <h2>{exhibition.name}</h2>
            <div className='detail-flex'>
            <p className='detail-left'>Museum</p>
            <p className='detail-right'><Link to={`/museums/list/all/detail/${exhibition.museum._id}`}>{exhibition.museum.name}</Link></p>
            </div>

            <div className='detail-flex'>
            <p className='detail-left'>Date</p>
            <p className='detail-right'>{exhibition.modifyOpnday} - {exhibition.modifyClsday}</p>
            </div>
         
            <div className='detail-flex'>
            <p className='detail-left'>Tickets</p>
            <p className='detail-right'>{exhibition.tickets}</p>
            </div>
            <div className='detail-flex'>
            <p className='detail-left'>Web-Site</p>
            <p className='detail-right'><a href={exhibition.website}>{exhibition.name}</a></p>
            </div>
            <div className='exhibition_img_wrapper'>
                <img src={exhibition.image}></img>
                <p>{exhibition.image_copyright}</p>
            </div>
            </div>:''}
        </div>
    )
};

export default ExhibitionDetail;